import React from 'react';

import * as ST from './styled';

export type TArticle = {
    question: string,
    answer: string,
    id: number,
}

interface IProps {
    title: string | React.ReactElement,
    questions: TArticle[],
}

export const Questions = ({ title, questions }: IProps): JSX.Element => {
    return (
        <ST.Questions>
            <div>
                {typeof title === 'string'
                    ? <ST.Title>{title}</ST.Title>
                    : title
                }
                <ST.Inner itemScope itemType='https://schema.org/FAQPage'>
                    {questions.map(({ id, question, answer }) => {
                        return (
                            <span key={id} itemScope itemProp='mainEntity' itemType='https://schema.org/Question'>
                                <ST.StyledAccordion
                                    theme='dark'
                                    title={question}
                                >
                                    <ST.QuestionText
                                        itemProp='text'
                                        itemType='https://schema.org/Answer'
                                        dangerouslySetInnerHTML={{ __html: answer }}
                                    />
                                </ST.StyledAccordion>
                            </span>
                        );
                    })}
                </ST.Inner>
            </div>
        </ST.Questions>
    );
};
